export const comments_list_locale = {
  FILTER: {
    NAME: "Name",
    DESCRIPTION: "Description",
    CATEGORY: "Category",
  }
};
